// extracted by mini-css-extract-plugin
export var downArrow = "_9z-0";
export var label = "_9z-1";
export var treatmentCard = "_9z-3";
export var upArrow = "_9z-2";